module.exports = __webpack_public_path__ + "img/cash_flow2.a174de72.jpg";